(function(){
  function init(){
    document.querySelectorAll('.td-product-section .tdp__rc-track').forEach(function(tr){
      if(tr.dataset.oux) return; tr.dataset.oux=1;
      var cards=tr.children; if(cards.length<2) return;
      var dots=document.createElement('div'); dots.className='oux-dots';
      for(var i=0;i<cards.length;i++){(function(i){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Review '+(i+1));b.addEventListener('click',function(){go(i);hold();});dots.appendChild(b);})(i);}
      tr.parentNode.insertBefore(dots,tr.nextSibling);
      function cur(){return Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth));}
      function paint(){var c=cur();[].forEach.call(dots.children,function(d,k){d.classList.toggle('is-on',k===c);});}
      function go(i){tr.scrollTo({left:cards[i].offsetLeft-tr.offsetLeft,behavior:'smooth'});}
      var t; tr.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(paint,60);},{passive:true}); paint();
      var timer=null,paused=false;
      function start(){if(timer||paused)return;timer=setInterval(function(){var n=cur()+1;go(n>=cards.length?0:n);},4500);}
      function stop(){clearInterval(timer);timer=null;}
      function hold(){paused=true;stop();setTimeout(function(){paused=false;start();},8000);}
      tr.addEventListener('touchstart',hold,{passive:true}); tr.addEventListener('pointerdown',hold);
      if(!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)){
        if('IntersectionObserver' in window){new IntersectionObserver(function(e){if(e[0].isIntersecting)start();else stop();},{threshold:.4}).observe(tr);}else start();
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
/* Packs of 2+ : keep only "You save $X" and add "+ Bonus Gift" line */
(function(){
  function fix(){
    var found=false;
    document.querySelectorAll('.td-pack').forEach(function(p){
      var inp=p.querySelector('input[name="td_pack"]'), sub=p.querySelector('.oup-sub');
      if(!inp||!sub) return; found=true;
      if(p.dataset.ouxg) return; p.dataset.ouxg=1;
      if((+inp.value||1)<2) return;
      sub.textContent=sub.textContent.split(' · ')[0];
      var g=document.createElement('span'); g.className='oux-gift'; g.textContent='+ Bonus Gift 🎁';
      g.style.cssText='display:block;font-size:13px;font-weight:800;color:#1a8f3c;margin-top:2px';
      sub.parentNode.insertBefore(g, sub.nextSibling);
    });
    return found;
  }
  var n=0; (function tick(){ if(!fix() && n++<50) setTimeout(tick,100); })();
})();
/* Foot Relief Massage Roller add-on (checkbox under the packs, added together with the insoles) */
(function(){
  var HANDLE = 'roller-yoga-massage';
  function money(c){ return '$' + (c/100).toFixed(2); }
  function build(){
    var packs = document.querySelector('.td-product-section [data-td-packs]');
    if (!packs || document.querySelector('[data-oux-addon]')) return;
    fetch('/products/' + HANDLE + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
      if (!p || !p.available || document.querySelector('[data-oux-addon]')) return;
      var vs = p.variants.filter(function(v){ return v.available; });
      if (!vs.length) return;
      var box = document.createElement('div'); box.className = 'tda'; box.setAttribute('data-oux-addon', '');
      var row = document.createElement('label'); row.className = 'tda__row';
      var cb = document.createElement('input'); cb.type = 'checkbox'; cb.setAttribute('data-td-addon', ''); cb.setAttribute('aria-label', 'Add ' + p.title);
      var im = document.createElement('span'); im.className = 'tda__img';
      if (p.featured_image) { var i = document.createElement('img'); i.loading = 'lazy'; i.alt = p.title; i.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120'; im.appendChild(i); }
      var tx = document.createElement('span'); tx.className = 'tda__txt';
      var b = document.createElement('b'); b.textContent = 'Add ' + p.title;
      var sm = document.createElement('small'); sm.textContent = 'Melt away foot tension after a long day';
      tx.appendChild(b); tx.appendChild(sm);
      var pr = document.createElement('span'); pr.className = 'tda__price'; pr.textContent = '+' + money(vs[0].price);
      if (vs[0].compare_at_price > vs[0].price) { var s = document.createElement('s'); s.textContent = money(vs[0].compare_at_price); pr.appendChild(s); }
      row.appendChild(cb); row.appendChild(im); row.appendChild(tx); row.appendChild(pr);
      box.appendChild(row);
      var vin;
      if (p.variants.length === 1) {
        vin = document.createElement('input'); vin.type = 'hidden'; vin.value = vs[0].id;
      } else {
        vin = document.createElement('select'); vin.className = 'tda__size'; vin.setAttribute('aria-label', 'Roller color');
        vs.forEach(function(v){ var o = document.createElement('option'); o.value = v.id; o.textContent = 'Color: ' + v.title; vin.appendChild(o); });
      }
      vin.setAttribute('data-td-addon-variant', '');
      box.appendChild(vin);
      packs.parentNode.insertBefore(box, packs.nextSibling);
    }).catch(function(){});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();
/* FIX tallas: el script de tallas se ejecuta antes de que exista el selector de variante, asi que nunca lo actualizaba.
   Aqui se sincroniza la talla elegida con el selector, al pulsar la talla y justo antes de anadir al carrito. */
(function(){
  function sel(){ return document.querySelector('.td-product-section select[name="id"]') || document.querySelector('select[name="id"]'); }
  function sync(v){ var s=sel(); if(!s||!v) return; if(s.value!==String(v)){ s.value=String(v); s.dispatchEvent(new Event('change',{bubbles:true})); } }
  document.addEventListener('click',function(e){ var b=e.target.closest&&e.target.closest('.ous__btn'); if(b&&!b.disabled) sync(b.dataset.v); });
  document.addEventListener('click',function(e){ var a=e.target.closest&&e.target.closest('[data-td-atc]'); if(!a) return; var on=document.querySelector('.ous__btn.is-on'); if(on) sync(on.dataset.v); },true);
  document.addEventListener('submit',function(e){ var on=document.querySelector('.ous__btn.is-on'); if(on) sync(on.dataset.v); },true);
})();
